import { Component, OnInit, Inject } from '@angular/core';
import { SalesDashboardService } from '../services/sales-dashboard.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalImageManagerComponent } from '../modal-image-manager/modal-image-manager.component';
import { ModalLogoutComponent } from '../shared/modals/modal-logout/modal-logout.component';
import { ModalShareEmailComponent } from '../shared/modals/modal-share-email/modal-share-email.component';
import { Project } from '../classes/project';
import { ProjectManagerService } from '../services/project-manager.service';
import { AuthService } from '../services/auth.service';
import { SetMaterialsService } from '../services/set-materials.service';
import { AppSettingsService } from '../services/app-settings.service';
import { SceneryService } from '../services/scenery.service';
import { StageService } from '../services/stage.service';
import { BuildFloorService } from '../services/build-floor.service';
import { SharedServiceService } from '../shared-service.service';
import { SnapShotService } from '../services/snap-shot.service';
import { DeckHeightService } from '../services/deck-height.service';
import { ProductsService } from '../services/products.service';
import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { Model3DService } from '../services/model3-d.service';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { ModalDeleteComponent } from '../shared/modals/modal-delete/modal-delete.component';
declare let THREE: any;


@Component({
  selector: 'app-sales-manager-dashboard',
  templateUrl: './sales-manager-dashboard.component.html',
  styleUrls: ['./sales-manager-dashboard.component.scss']
})
export class SalesManagerDashboardComponent implements OnInit {

  showSalesDashboard: boolean = false;
  showFiltersList: boolean = false;
  private projects: Project[];

  constructor(
    private salesDashboardService: SalesDashboardService,
    public dialog: MatDialog,
    private projectManagerService: ProjectManagerService,
    private auth: AuthService,
    private setMaterialService: SetMaterialsService,
    private appSettingsService: AppSettingsService,
    private sceneryService: SceneryService,
    private buildFloor: BuildFloorService,
    private projectSrvc: ProjectManagerService,
    private snapshotSrvc: SnapShotService,
    private deckHeightService: DeckHeightService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private model3D: Model3DService,
    private loadingSpinnerService: LoadingSpinnerService,
    private productSrvc: ProductsService,
    private stage: StageService
  ) {
    this.salesDashboardService.projTodeleteIdSubj.subscribe(prjId =>{
      let index = this.projects.findIndex(prj => {return prj.id === prjId});
      this.projects.splice(index, 1);
    })
  }

  ngOnInit() {
    this.getProjects();
    this.salesDashboardService.dashBouardIsActive.subscribe(value => {
      setTimeout(() => {
        this.showSalesDashboard = value;
        this.getProjects();
      }, 0);
    });
  }

  getProjects(): void {
    if (this.auth.getRole() == "admin") {
      this.projectManagerService.getAllUsersProjects().subscribe(projs => {
        this.projects = projs;
      });
    }
    else if (this.auth.getRole() == "salesManager") {
      this.projectManagerService.getProjects(this.auth.getUserId()).subscribe(projs => {
        this.projects = projs;
      });
    }
  }

  hideDashboard() {
    this.salesDashboardService.hideDashbouard();
  }

  openViewImagesDialog(proj): void {
    this.dialog.open(ModalImageManagerComponent, {
      width: '60%'
    });
    let imageMangerData: object = {};
    imageMangerData["snapshotsProTools"] = proj.snapshotsProTools;
    imageMangerData["projectName"] = proj.projectName;
    imageMangerData["id"] = proj.id;
    this.salesDashboardService.openSelectedProject(imageMangerData);
  }

  openFiltersList() {
    if (this.showFiltersList) {
      this.showFiltersList = false;
    }
    else {
      this.showFiltersList = true;
    }
  }

  logOff() {
    this.salesDashboardService.hideDashbouard();
    this.dialog.open(ModalLogoutComponent, {
      width: '455px'
    });
  }
  share(project) {
    this.salesDashboardService.setSelectedProjectId(project.id)
    this.dialog.open(ModalShareEmailComponent, {
      width: '455px'
    });
  }

  delete(project){
    this.salesDashboardService.setSelectedProjectId(project.id);
    this.dialog.open(ModalDeleteComponent, {
      width: '455px'
    });
  }

  openProject(project): void {

    this.hideDashboard();
    if (this.auth.getRole() !== "admin") {
      this.snapshotSrvc.setSnapshots(project.snapshots);
    }
    this.snapshotSrvc.setSnapshotsProTools(project.snapshotsProTools);
    this.buildFloor.removeFloor();
    this.projectSrvc.setProject(project);
    this.projectSrvc.setIsSavedProject(true);
    this.deckHeightService.setDeckHeight(project.deckHeight || 8);
    this.setMaterialService.setMaterial(project.deckMaterial);
    this.buildFloors(project.tiers);
    this.buildAccessories(project.accessories);
    this.appSettingsService.setScenery(project.scenery);
    this.sceneryService.change(project.scenery);
    this.dataForDisplayingMenuItemsService.setCurrentParams(project.railing);
    // this.dataForDisplayingMenuItemsService.setDefaultParams();
  }

  buildFloors(tiers: any[]): void {
    for (let tier of tiers) {
      this.buildFloor.buildFloor({ points: tier.points, height: tier.height, mainFloor: tier.mainFloor, customId: tier.customId });
    }
  }

  // to do refactor
  // this code is present in 2 places
  buildAccessories(accessories): void {
    for (let accessory of accessories) {
      this.productSrvc.getAccessories()
        .then(accessories => {
          const activeEntity = accessories.find(a => a.id === accessory.id);
          const rotation = new THREE.Euler(accessory.rotation.x, accessory.rotation.y, accessory.rotation.z, 'XYZ');
          this.loadingSpinnerService.spinnerLoadingListAdd('buildAccessories' + accessory.id);
          this.model3D.create(activeEntity, {
            position: accessory.position,
            rotation: rotation,
            wall: null,
            show3DObject: true
          }).then(obj => {
            // obj.userData.boundingBox = boundingBox;
            obj.userData.entity = activeEntity;
            obj.name = activeEntity.productType;
            const tiers = this.stage.getCompoundFloor().children;
            const tier = tiers.find(t => t.userData.customId === accessory.parentId);
            if (tier) {
              tier.updateMatrixWorld(true);
              obj.updateMatrixWorld(true);
              this.stage.getScene().updateMatrixWorld(true);
              THREE.SceneUtils.attach(obj, this.stage.getScene(), tier);
            }
            this.loadingSpinnerService.spinnerLoadingListRemove('buildAccessories' + accessory.id);
          });
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/sales-manager-dashboard/sales-manager-dashboard.component.ts